/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  QraftServiceOperationsToken,
  RequestFnResponse,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationUseMutationOptions,
} from '@openapi-qraft/tanstack-query-react-types';
import type { Mutation, MutationCache, MutationState, UseMutationResult } from '@tanstack/react-query';

import type { paths } from '../schema';

export interface ServicePlansService {
  /**
   * @summary Create Service Plan
   * @description Creates a service plan for a customer from a template.
   *
   * This endpoint creates a new service plan for the specified customer
   * using the provided template. Overrides can be specified to customize
   * the service plan values.
   */
  createServicePlanCustomersCustomerIdServicePlansPost: {
    /**
     * @summary Create Service Plan
     * @description Creates a service plan for a customer from a template.
     *
     * This endpoint creates a new service plan for the specified customer
     * using the provided template. Overrides can be specified to customize
     * the service plan values.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CreateServicePlanCustomersCustomerIdServicePlansPostBody,
        CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CreateServicePlanCustomersCustomerIdServicePlansPostSchema,
        options: ServiceOperationMutationFnOptions<
          CreateServicePlanCustomersCustomerIdServicePlansPostBody,
          CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CreateServicePlanCustomersCustomerIdServicePlansPostData,
          CreateServicePlanCustomersCustomerIdServicePlansPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CreateServicePlanCustomersCustomerIdServicePlansPostData,
        CreateServicePlanCustomersCustomerIdServicePlansPostError
      >
    >;
    /**
     * @summary Create Service Plan
     * @description Creates a service plan for a customer from a template.
     *
     * This endpoint creates a new service plan for the specified customer
     * using the provided template. Overrides can be specified to customize
     * the service plan values.
     */
    getMutationKey(
      parameters: DeepReadonly<CreateServicePlanCustomersCustomerIdServicePlansPostParameters> | void
    ): ServiceOperationMutationKey<
      CreateServicePlanCustomersCustomerIdServicePlansPostSchema,
      CreateServicePlanCustomersCustomerIdServicePlansPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Service Plan
     * @description Creates a service plan for a customer from a template.
     *
     * This endpoint creates a new service plan for the specified customer
     * using the provided template. Overrides can be specified to customize
     * the service plan values.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.createServicePlanCustomersCustomerIdServicePlansPost.useMutation({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.createServicePlanCustomersCustomerIdServicePlansPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends CreateServicePlanCustomersCustomerIdServicePlansPostBody, TContext = unknown>(
      parameters: DeepReadonly<CreateServicePlanCustomersCustomerIdServicePlansPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CreateServicePlanCustomersCustomerIdServicePlansPostSchema,
        CreateServicePlanCustomersCustomerIdServicePlansPostData,
        CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
        TVariables,
        OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateServicePlanCustomersCustomerIdServicePlansPostData,
      OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Create Service Plan
     * @description Creates a service plan for a customer from a template.
     *
     * This endpoint creates a new service plan for the specified customer
     * using the provided template. Overrides can be specified to customize
     * the service plan values.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.createServicePlanCustomersCustomerIdServicePlansPost.useMutation({
     *     path: {
     *         customer_id: customerId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.createServicePlanCustomersCustomerIdServicePlansPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CreateServicePlanCustomersCustomerIdServicePlansPostBody,
        CreateServicePlanCustomersCustomerIdServicePlansPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CreateServicePlanCustomersCustomerIdServicePlansPostSchema,
        CreateServicePlanCustomersCustomerIdServicePlansPostData,
        CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
        TVariables,
        OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
        TContext
      >
    ): UseMutationResult<
      CreateServicePlanCustomersCustomerIdServicePlansPostData,
      OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Create Service Plan
     * @description Creates a service plan for a customer from a template.
     *
     * This endpoint creates a new service plan for the specified customer
     * using the provided template. Overrides can be specified to customize
     * the service plan values.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const createServicePlanCustomersCustomerIdServicePlansPostTotal = qraft.servicePlansService.createServicePlanCustomersCustomerIdServicePlansPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const createServicePlanCustomersCustomerIdServicePlansPostTotal = qraft.servicePlansService.createServicePlanCustomersCustomerIdServicePlansPost.useIsMutating({
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CreateServicePlanCustomersCustomerIdServicePlansPostBody,
            CreateServicePlanCustomersCustomerIdServicePlansPostData,
            CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
            OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServicePlanCustomersCustomerIdServicePlansPostSchema,
            CreateServicePlanCustomersCustomerIdServicePlansPostBody,
            CreateServicePlanCustomersCustomerIdServicePlansPostData,
            CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
            OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Create Service Plan
     * @description Creates a service plan for a customer from a template.
     *
     * This endpoint creates a new service plan for the specified customer
     * using the provided template. Overrides can be specified to customize
     * the service plan values.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const createServicePlanCustomersCustomerIdServicePlansPostPendingMutationVariables = qraft.servicePlansService.createServicePlanCustomersCustomerIdServicePlansPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const createServicePlanCustomersCustomerIdServicePlansPostMutationData = qraft.servicePlansService.createServicePlanCustomersCustomerIdServicePlansPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 customer_id: customerId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CreateServicePlanCustomersCustomerIdServicePlansPostData,
        OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
        MutationVariables<
          CreateServicePlanCustomersCustomerIdServicePlansPostBody,
          CreateServicePlanCustomersCustomerIdServicePlansPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CreateServicePlanCustomersCustomerIdServicePlansPostBody,
            CreateServicePlanCustomersCustomerIdServicePlansPostData,
            CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
            OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServicePlanCustomersCustomerIdServicePlansPostSchema,
            CreateServicePlanCustomersCustomerIdServicePlansPostBody,
            CreateServicePlanCustomersCustomerIdServicePlansPostData,
            CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
            OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CreateServicePlanCustomersCustomerIdServicePlansPostData,
          OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
          MutationVariables<
            CreateServicePlanCustomersCustomerIdServicePlansPostBody,
            CreateServicePlanCustomersCustomerIdServicePlansPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Create Service Plan
     * @description Creates a service plan for a customer from a template.
     *
     * This endpoint creates a new service plan for the specified customer
     * using the provided template. Overrides can be specified to customize
     * the service plan values.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CreateServicePlanCustomersCustomerIdServicePlansPostBody,
            CreateServicePlanCustomersCustomerIdServicePlansPostData,
            CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
            OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CreateServicePlanCustomersCustomerIdServicePlansPostSchema,
            CreateServicePlanCustomersCustomerIdServicePlansPostBody,
            CreateServicePlanCustomersCustomerIdServicePlansPostData,
            CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
            OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Create Service Plan
     * @description Creates a service plan for a customer from a template.
     *
     * This endpoint creates a new service plan for the specified customer
     * using the provided template. Overrides can be specified to customize
     * the service plan values.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.servicePlansService.createServicePlanCustomersCustomerIdServicePlansPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             customer_id: customerId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.servicePlansService.createServicePlanCustomersCustomerIdServicePlansPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CreateServicePlanCustomersCustomerIdServicePlansPostBody,
              CreateServicePlanCustomersCustomerIdServicePlansPostData,
              CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
              OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServicePlanCustomersCustomerIdServicePlansPostSchema,
              CreateServicePlanCustomersCustomerIdServicePlansPostBody,
              CreateServicePlanCustomersCustomerIdServicePlansPostData,
              CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
              OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
              TContext
            >
      ):
        | Mutation<
            CreateServicePlanCustomersCustomerIdServicePlansPostData,
            CreateServicePlanCustomersCustomerIdServicePlansPostError,
            MutationVariables<
              CreateServicePlanCustomersCustomerIdServicePlansPostBody,
              CreateServicePlanCustomersCustomerIdServicePlansPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CreateServicePlanCustomersCustomerIdServicePlansPostBody,
              CreateServicePlanCustomersCustomerIdServicePlansPostData,
              CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
              OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CreateServicePlanCustomersCustomerIdServicePlansPostSchema,
              CreateServicePlanCustomersCustomerIdServicePlansPostBody,
              CreateServicePlanCustomersCustomerIdServicePlansPostData,
              CreateServicePlanCustomersCustomerIdServicePlansPostParameters,
              OperationError<CreateServicePlanCustomersCustomerIdServicePlansPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CreateServicePlanCustomersCustomerIdServicePlansPostData,
          CreateServicePlanCustomersCustomerIdServicePlansPostError,
          MutationVariables<
            CreateServicePlanCustomersCustomerIdServicePlansPostBody,
            CreateServicePlanCustomersCustomerIdServicePlansPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CreateServicePlanCustomersCustomerIdServicePlansPostSchema;
    types: {
      parameters: CreateServicePlanCustomersCustomerIdServicePlansPostParameters;
      data: CreateServicePlanCustomersCustomerIdServicePlansPostData;
      error: CreateServicePlanCustomersCustomerIdServicePlansPostError;
      body: CreateServicePlanCustomersCustomerIdServicePlansPostBody;
    };
  };
  /**
   * @summary Update Service Plan
   * @description Updates an existing service plan.
   */
  updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch: {
    /**
     * @summary Update Service Plan
     * @description Updates an existing service plan.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema,
        options: ServiceOperationMutationFnOptions<
          UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
          UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
          UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError
        >
      >
    ): Promise<
      RequestFnResponse<
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError
      >
    >;
    /**
     * @summary Update Service Plan
     * @description Updates an existing service plan.
     */
    getMutationKey(
      parameters: DeepReadonly<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters> | void
    ): ServiceOperationMutationKey<
      UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema,
      UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Service Plan
     * @description Updates an existing service plan.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch.useMutation({
     *     path: {
     *         customer_id: customerId,
     *         service_plan_id: servicePlanId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId,
     *         service_plan_id: servicePlanId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters>,
      options?: ServiceOperationUseMutationOptions<
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema,
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
        TVariables,
        OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
      OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Update Service Plan
     * @description Updates an existing service plan.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch.useMutation({
     *     path: {
     *         customer_id: customerId,
     *         service_plan_id: servicePlanId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId,
     *         service_plan_id: servicePlanId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema,
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
        TVariables,
        OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
        TContext
      >
    ): UseMutationResult<
      UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
      OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Update Service Plan
     * @description Updates an existing service plan.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchTotal = qraft.servicePlansService.updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchTotal = qraft.servicePlansService.updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch.useIsMutating({
     *     parameters: {
     *         path: {
     *             customer_id: customerId,
     *             service_plan_id: servicePlanId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
            OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
            OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Update Service Plan
     * @description Updates an existing service plan.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchPendingMutationVariables = qraft.servicePlansService.updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchMutationData = qraft.servicePlansService.updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 customer_id: customerId,
     *                 service_plan_id: servicePlanId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
        OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
        MutationVariables<
          UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
          UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
            OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
            OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
          OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
          MutationVariables<
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Update Service Plan
     * @description Updates an existing service plan.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
            OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
            OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Update Service Plan
     * @description Updates an existing service plan.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.servicePlansService.updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             customer_id: customerId,
     *             service_plan_id: servicePlanId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.servicePlansService.updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
              OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema,
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
              OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
              TContext
            >
      ):
        | Mutation<
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError,
            MutationVariables<
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
              OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema,
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
              UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters,
              OperationError<UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError>,
              TContext
            >
      ): Array<
        Mutation<
          UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData,
          UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError,
          MutationVariables<
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody,
            UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters
          >,
          TContext
        >
      >;
    };
    schema: UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema;
    types: {
      parameters: UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters;
      data: UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData;
      error: UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError;
      body: UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody;
    };
  };
  /**
   * @summary Cancel Service Plan
   * @description Cancels a service plan.
   *
   * Sets the cancelled_at timestamp to mark the service plan as cancelled.
   */
  cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost: {
    /**
     * @summary Cancel Service Plan
     * @description Cancels a service plan.
     *
     * Sets the cancelled_at timestamp to mark the service plan as cancelled.
     */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema,
        options: ServiceOperationMutationFnOptions<
          CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
          CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<
        RequestFnResponse<
          CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
          CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError
        >
      >
    ): Promise<
      RequestFnResponse<
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError
      >
    >;
    /**
     * @summary Cancel Service Plan
     * @description Cancels a service plan.
     *
     * Sets the cancelled_at timestamp to mark the service plan as cancelled.
     */
    getMutationKey(
      parameters: DeepReadonly<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters> | void
    ): ServiceOperationMutationKey<
      CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema,
      CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Cancel Service Plan
     * @description Cancels a service plan.
     *
     * Sets the cancelled_at timestamp to mark the service plan as cancelled.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost.useMutation({
     *     path: {
     *         customer_id: customerId,
     *         service_plan_id: servicePlanId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId,
     *         service_plan_id: servicePlanId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
      TContext = unknown,
    >(
      parameters: DeepReadonly<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema,
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
        TVariables,
        OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
        TContext
      >
    ): UseMutationResult<
      CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
      OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Cancel Service Plan
     * @description Cancels a service plan.
     *
     * Sets the cancelled_at timestamp to mark the service plan as cancelled.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost.useMutation({
     *     path: {
     *         customer_id: customerId,
     *         service_plan_id: servicePlanId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.servicePlansService.cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     path: {
     *         customer_id: customerId,
     *         service_plan_id: servicePlanId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema,
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
        TVariables,
        OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
        TContext
      >
    ): UseMutationResult<
      CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
      OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Cancel Service Plan
     * @description Cancels a service plan.
     *
     * Sets the cancelled_at timestamp to mark the service plan as cancelled.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostTotal = qraft.servicePlansService.cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostTotal = qraft.servicePlansService.cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost.useIsMutating({
     *     parameters: {
     *         path: {
     *             customer_id: customerId,
     *             service_plan_id: servicePlanId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
            OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
            OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Cancel Service Plan
     * @description Cancels a service plan.
     *
     * Sets the cancelled_at timestamp to mark the service plan as cancelled.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostPendingMutationVariables = qraft.servicePlansService.cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostMutationData = qraft.servicePlansService.cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             path: {
     *                 customer_id: customerId,
     *                 service_plan_id: servicePlanId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
        OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
        MutationVariables<
          CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
          CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters
        >,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
            OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
            OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
          OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
          MutationVariables<
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters
          >,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /**
     * @summary Cancel Service Plan
     * @description Cancels a service plan.
     *
     * Sets the cancelled_at timestamp to mark the service plan as cancelled.
     */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
            OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
            OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Cancel Service Plan
     * @description Cancels a service plan.
     *
     * Sets the cancelled_at timestamp to mark the service plan as cancelled.
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.servicePlansService.cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         path: {
     *             customer_id: customerId,
     *             service_plan_id: servicePlanId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.servicePlansService.cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
              OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema,
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
              OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
              TContext
            >
      ):
        | Mutation<
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError,
            MutationVariables<
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters
            >,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
              OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema,
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
              CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters,
              OperationError<CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError>,
              TContext
            >
      ): Array<
        Mutation<
          CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData,
          CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError,
          MutationVariables<
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody,
            CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters
          >,
          TContext
        >
      >;
    };
    schema: CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema;
    types: {
      parameters: CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters;
      data: CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData;
      error: CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError;
      body: CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody;
    };
  };
}
/**
 * @summary Create Service Plan
 * @description Creates a service plan for a customer from a template.
 *
 * This endpoint creates a new service plan for the specified customer
 * using the provided template. Overrides can be specified to customize
 * the service plan values.
 */
export const createServicePlanCustomersCustomerIdServicePlansPost = {
  schema: {
    method: 'post',
    url: '/customers/{customer_id}/service_plans',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: CreateServicePlanCustomersCustomerIdServicePlansPostSchema;
  [QraftServiceOperationsToken]: ServicePlansService['createServicePlanCustomersCustomerIdServicePlansPost'];
};
/**
 * @summary Update Service Plan
 * @description Updates an existing service plan.
 */
export const updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch = {
  schema: {
    method: 'patch',
    url: '/customers/{customer_id}/service_plans/{service_plan_id}',
    mediaType: ['application/json'],
    security: ['HTTPBearer'],
  },
} as {
  schema: UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema;
  [QraftServiceOperationsToken]: ServicePlansService['updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch'];
};
/**
 * @summary Cancel Service Plan
 * @description Cancels a service plan.
 *
 * Sets the cancelled_at timestamp to mark the service plan as cancelled.
 */
export const cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost = {
  schema: {
    method: 'post',
    url: '/customers/{customer_id}/service_plans/{service_plan_id}/cancel',
    security: ['HTTPBearer'],
  },
} as {
  schema: CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema;
  [QraftServiceOperationsToken]: ServicePlansService['cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost'];
};
export const servicePlansService = {
  createServicePlanCustomersCustomerIdServicePlansPost,
  updateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatch,
  cancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPost,
} as const;
type CreateServicePlanCustomersCustomerIdServicePlansPostSchema = {
  method: 'post';
  url: '/customers/{customer_id}/service_plans';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type CreateServicePlanCustomersCustomerIdServicePlansPostParameters =
  paths['/customers/{customer_id}/service_plans']['post']['parameters'];
type CreateServicePlanCustomersCustomerIdServicePlansPostData =
  paths['/customers/{customer_id}/service_plans']['post']['responses']['201']['content']['application/json'];
type CreateServicePlanCustomersCustomerIdServicePlansPostError =
  paths['/customers/{customer_id}/service_plans']['post']['responses']['422']['content']['application/json'];
type CreateServicePlanCustomersCustomerIdServicePlansPostBody =
  paths['/customers/{customer_id}/service_plans']['post']['requestBody']['content']['application/json'];
type UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchSchema = {
  method: 'patch';
  url: '/customers/{customer_id}/service_plans/{service_plan_id}';
  mediaType: ['application/json'];
  security: ['HTTPBearer'];
};
type UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchParameters =
  paths['/customers/{customer_id}/service_plans/{service_plan_id}']['patch']['parameters'];
type UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchData =
  paths['/customers/{customer_id}/service_plans/{service_plan_id}']['patch']['responses']['200']['content']['application/json'];
type UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchError =
  paths['/customers/{customer_id}/service_plans/{service_plan_id}']['patch']['responses']['422']['content']['application/json'];
type UpdateServicePlanCustomersCustomerIdServicePlansServicePlanIdPatchBody =
  paths['/customers/{customer_id}/service_plans/{service_plan_id}']['patch']['requestBody']['content']['application/json'];
type CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostSchema = {
  method: 'post';
  url: '/customers/{customer_id}/service_plans/{service_plan_id}/cancel';
  security: ['HTTPBearer'];
};
type CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostParameters =
  paths['/customers/{customer_id}/service_plans/{service_plan_id}/cancel']['post']['parameters'];
type CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostData =
  paths['/customers/{customer_id}/service_plans/{service_plan_id}/cancel']['post']['responses']['200']['content']['application/json'];
type CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostError =
  paths['/customers/{customer_id}/service_plans/{service_plan_id}/cancel']['post']['responses']['422']['content']['application/json'];
type CancelServicePlanCustomersCustomerIdServicePlansServicePlanIdCancelPostBody = undefined;
